<template>
  <b-row class="m-0 w-100" :class="!isDownloadable ? 'justify-content-center' : 'wrapper'">
    <b-col v-if="badgeInfo" class="container__badge-detail px-xl-0">
      <div
        class="card__badge-detail"
        :class="isDownloadable ? 'card__badge-detail-downloading' : ''"
      >
        <div class="badge-detail__left">
          <!-- BadgeImage -->

          <badge-image class="image__badge" :src="badgeImageUrl" large centered :lazy-load="false">
          </badge-image>
        </div>

        <div class="badge-detail__right">
          <!-- Badge type -->
          <div v-if="badgeInfo.learning_unit.level_type" class="text-primary mb-2 text__badge-type">
            <b-img
              class="image__mc-icon mr-1"
              :src="
                badgeInfo.learning_unit.level_type === 'CAREER_SPECIFIC'
                  ? specificIcon
                  : academicIcon
              "
              height="16"
            />

            <span class="text__mc-type">
              {{
                badgeInfo.learning_unit.level_type === 'CAREER_SPECIFIC'
                  ? 'Career Specific'
                  : 'Academic Focused'
              }}
            </span>
          </div>

          <!-- Badge name -->
          <div v-if="badgeInfo.learning_unit" class="font-weight-bold mb-2 text__mc-title">
            {{ badgeInfo.learning_unit.name }}
          </div>

          <!-- badge Issued to -->
          <div class="mb-2">
            <span class="text-black-50">Issued to</span>
            <span class="font-weight-bold text__recipient">
              {{ badgeInfo.issued_to }}
            </span>
          </div>

          <!-- badge text verified -->
          <b-badge pill variant="neutral-success" class="text-success text-badge__verified">
            <span>
              <font-awesome-icon
                :icon="{ prefix: 'far', iconName: 'circle-check' }"
                class="icon-badge__verified"
              />
              <span> VERIFIED </span>
            </span>
          </b-badge>

          <hr />

          <!-- badge competency -->
          <div class="mb-3">
            <div class="font-weight-bold mb-1 text__competency-title">Competency</div>
            <div
              v-safe-html="badgeInfo.learning_unit.competency_detail"
              class="text__competency"
            ></div>
          </div>

          <!-- badge Issued by / Issued on -->
          <b-row class="text-badge__issued">
            <b-col sm="8" lg="6">
              <div class="font-weight-bold mb-1 text__issued-by-title">Issued by</div>
              <a :href="badgeInfo.url" target="_blank" class="text__issued-by">
                <b-img class="img__kmutt-logo" :src="kmuttLogo" width="30" height="35" />

                <div class="text-black-50 text__kumutt">
                  King Mongkut’s University of Technology Thonburi
                </div>
              </a>
            </b-col>
            <b-col sm="4" lg="6">
              <div class="font-weight-bold mb-1 text__issue-date-title">Issued on</div>
              <span class="text-black-50 text__issue-date">
                {{ formatedDatetime(badgeInfo.issued_on, 'MMM D, YYYY') }}
              </span>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BadgeImage from '@/components/Credential/BadgeImage.vue';
import { datetimeMixin } from '@/mixins/datetimeMixin';
import { Utility } from '@/models/Utility';

import kmuttLogoPng from '@/assets/kmutt-logo.png';
import specificSvg from '@/assets/learning-unit-types/specific.svg';
import academicSvg from '@/assets/learning-unit-types/academic.svg';

library.add(faCircleCheck);

export default {
  components: {
    BadgeImage,
    FontAwesomeIcon
  },
  mixins: [datetimeMixin],
  props: {
    badgeInfo: {
      type: Object,
      default: () => {}
    },
    isDownloadable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      kmuttLogo: kmuttLogoPng,
      specificIcon: specificSvg,
      academicIcon: academicSvg
    };
  },

  computed: {
    badgeImageUrl() {
      if (!this.badgeInfo?.learning_unit?.badge_image?.[0]?.url) return '';
      return Utility.apiConfig.actions.getProxyImageUrl(
        this.badgeInfo.learning_unit.badge_image[0].url
      );
    }
  },

  mounted() {
    const image = this.$el.querySelector('.image__badge img');
    if (image) {
      console.log('image', image.src);

      image.onload = () => {
        this.$emit('ready');
      };
    }
  }
};
</script>

<style lang="scss" scoped>
hr {
  width: 100%;
}

@media screen and (min-width: 1200px) {
  .wrapper {
    padding-left: 20px;
  }
}

.container__badge-detail {
  padding: 0 32px;
  margin-bottom: 40px;
  .card__badge-detail-downloading {
    min-width: 1000px;
    min-height: 474px;
  }

  .card__badge-detail {
    max-width: 910px;
    display: flex;
    margin: auto;
    gap: 40px;
    padding: 40px;
    background-color: #ffffff;
    border: 1px solid #d1d2db;

    border-radius: 12px;
  }
  .badge-detail__right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }

  .text__badge-type {
    display: flex;
    align-items: center;

    .text__mc-type {
      font-weight: 500;
    }
  }

  .text__mc-title {
    font-size: 28px;
    line-height: 39px;
  }

  .badge.text-badge__verified {
    height: 32px;
    line-height: 20px;
    width: 120px;
  }

  .badge-pill.text-badge__verified {
    font-size: 16px;
    padding: 6px 9px;
  }

  .text__issued-by {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  // custom style for responsive size

  @media screen and (max-width: 576px) {
    .card__badge-detail {
      flex-direction: column;
    }
  }

  @media screen and (max-width: 575px) {
    .card__badge-detail {
      padding: 40px 20px;
    }

    .text-badge__issued {
      flex-direction: column;
      gap: 20px;
    }
  }

  @media screen and (max-width: 375px) {
    .text__mc-title {
      font-size: 24px;
    }
  }
}

@media screen and (max-width: 375px) {
  .container__badge-detail {
    padding: 0 16px;
  }
}
</style>
